import { AppointmentsListCard } from '../components/AppointmentsListCard';
import { AdminToolsCard } from '../components/cards/AdminToolsCard';
import { NotesCard } from '../components/cards/NotesCard';
import { NotesToReviewCard } from '../components/cards/NotesToReviewCard';
import { OnboardingCard } from '../components/cards/OnboardingCard';
import { PatientCard } from '../components/cards/PatientCard';
import { RecordCard } from '../components/cards/RecordCard';
import { RequestPaymentCard } from '../components/cards/RequestPaymentCard';
import { ScheduleAppointmentCard } from '../components/cards/ScheduleAppointmentCard';
import { ShareJotPsychCard } from '../components/cards/ShareJotPsychCard';
import { UpcomingAppointmentsCard } from '../components/cards/UpcomingAppointmentsCard';

/**
 * Registry mapping card IDs to their React components.
 * This allows for dynamic component rendering based on configuration.
 */
export const CARD_REGISTRY = {
  'appointments-list': AppointmentsListCard,
  record: RecordCard,
  notes: NotesCard,
  'schedule-appointment': ScheduleAppointmentCard,
  'request-payment': RequestPaymentCard,
  patient: PatientCard,
  onboarding: OnboardingCard,
  'upcoming-appointments': UpcomingAppointmentsCard,
  'admin-tools': AdminToolsCard,
  'notes-review': NotesToReviewCard,
  'share-jotpsych': ShareJotPsychCard,
} as const;

export type CardId = keyof typeof CARD_REGISTRY;
